import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fced825"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create-report-form-title" }, "Создание формы", -1))
const _hoisted_2 = { class: "create-report-form" }
const _hoisted_3 = { class: "create-report-form-content" }
const _hoisted_4 = { class: "create-report-form-footer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TSelectComponent = _resolveComponent("TSelectComponent")!
  const _component_TInputComponent = _resolveComponent("TInputComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 24px;",
    style: {"width":"1200px"},
    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
  }, {
    body: _withCtx(({ close }) => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_TSelectComponent, {
            modelValue: _ctx.formData.decree,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.decree) = $event)),
              _cache[2] || (_cache[2] = ($event: any) => (_ctx.model.decree.error = null))
            ],
            error: _ctx.model.decree.error,
            required: _ctx.model.decree.required,
            caption: "Список приказов",
            "options-url": "/api/repository/decrees/types?action=list",
            "options-url-default-key": "default",
            "reselect-init-value": "",
            onReset: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.decree = null))
          }, null, 8, ["modelValue", "error", "required"]),
          _createVNode(_component_TSelectComponent, {
            modelValue: _ctx.formData.author,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.author) = $event)),
              _cache[5] || (_cache[5] = ($event: any) => (_ctx.model.author.error = null))
            ],
            error: _ctx.model.author.error,
            required: _ctx.model.author.required,
            caption: "Организация",
            "options-url": "/api/vocs?action=list_organizations&for_current_user=true",
            onReset: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.author = null))
          }, null, 8, ["modelValue", "error", "required"]),
          _createVNode(_component_TSelectComponent, {
            modelValue: _ctx.formData.report_type,
            "onUpdate:modelValue": [
              _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.report_type) = $event)),
              _cache[8] || (_cache[8] = ($event: any) => (_ctx.model.report_type.error = null))
            ],
            error: _ctx.model.report_type.error,
            "options-url": 
              _ctx.ApiService.getUrl(`/api/repository/reports/types?`, {
                action: 'list',
                journal_name: _ctx.journalName,
              })
            ,
            required: _ctx.model.report_type.required,
            "reselect-init-value": true,
            caption: "Тип отчёта",
            "options-url-default-key": "default",
            onReset: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.report_type = null))
          }, null, 8, ["modelValue", "error", "options-url", "required"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.reportingForms, (_, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "create-report-form__select-form-container"
            }, [
              _createVNode(_component_TSelectComponent, {
                modelValue: _ctx.formData.reportingForms[i].selectValue,
                "onUpdate:modelValue": [
                  ($event: any) => ((_ctx.formData.reportingForms[i].selectValue) = $event),
                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.model.reportingForms.error = null))
                ],
                error: _ctx.model.reportingForms.error,
                "excluded-values": _ctx.reportingFormsExcluded,
                "options-url": 
                _ctx.formData.report_type &&
                _ctx.ApiService.getUrl('/api/repository/forms/types?', {
                  action: 'list_by_report_num',
                  report_num: _ctx.formData.report_type.value,
                  preset: _ctx.preset,
                  journal_name: _ctx.journalName,
                  decree: _ctx.formData.decree?.value,
                })
              ,
                required: _ctx.model.reportingForms.required,
                caption: "Отчётная форма",
                "options-url-default-key": "default",
                onReset: ($event: any) => (_ctx.formData.reportingForms[i].selectValue = undefined)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "excluded-values", "options-url", "required", "onReset"]),
              false
                ? (_openBlock(), _createBlock(_component_TInputComponent, {
                    key: 0,
                    modelValue: _ctx.formData.reportingForms[i].form_period_start,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData.reportingForms[i].form_period_start) = $event),
                    "force-change-model-value": _ctx.formData.reportingForms[i],
                    caption: "Начало периода",
                    type: "date",
                    onReset: ($event: any) => (_ctx.formData.reportingForms[i].form_period_start = undefined)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "force-change-model-value", "onReset"]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createBlock(_component_TInputComponent, {
                    key: 1,
                    modelValue: _ctx.formData.reportingForms[i].form_period_end,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData.reportingForms[i].form_period_end) = $event),
                    "force-change-model-value": _ctx.formData.reportingForms[i],
                    caption: "Конец периода",
                    type: "date",
                    onReset: ($event: any) => (_ctx.formData.reportingForms[i].form_period_end = undefined)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "force-change-model-value", "onReset"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_ButtonComponent, {
            class: "form-button",
            "data-type": "gray",
            onClick: _ctx.onCreateReport
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Создать форму ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}